export default __webpack_public_path__ + "static/media/dapps5.01b54f0c.jpg";